/* istanbul ignore file */
import { isBrowser } from '@noths/polaris-client-utils';
import histore from 'histore';

export const pageHistory = isBrowser() ? histore() : null;
